import useSWR from 'swr';
import { IOption } from 'utility/node/claim/file-claim/question';
import { getFileClaimEventOptions } from 'utility/node/routes';

export const useFileClaimEventOptions = (
  policyId: number,
  fetch: boolean = true,
  objectId: number,
) => {
  const { data, error, mutate } = useSWR<IOption[]>(
    fetch ? getFileClaimEventOptions(policyId, objectId) : null,
  );

  return {
    eventOptions: data,
    eventOptionsErrors: error,
    mutateEventOptions: mutate,
    eventOptionsLoading: !data && !error && fetch,
  };
};
